export const REQUEST_DELIVERY_SLOTS = '@CINCH/REQUEST_DELIVERY_SLOT'
export const RECEIVE_DELIVERY_SLOTS = '@CINCH/RECEIVE_DELIVERY_SLOTS'
export const ERROR_DELIVERY_SLOTS = '@CINCH/ERROR_DELIVERY_SLOTS'
export const SELECT_DELIVERY_SLOT = '@CINCH/SELECT_DELIVERY_SLOT'
export const DELIVERY_ADDRESS_INPUT = '@CINCH/DELIVERY_ADDRESS_INPUT'

export const ORDER_ADD_ADDRESS_REQUEST = '@CINCH/ORDER_ADD_ADDRESS_REQUEST'
export const ORDER_ADD_ADDRESS_COMPLETE = '@CINCH/ORDER_ADD_ADDRESS_COMPLETE'
export const ORDER_ADD_ADDRESS_ERROR = '@CINCH/ORDER_ADD_ADDRESS_ERROR'

export const ORDER_CREATE_REQUEST = '@CINCH/ORDER_CREATE_REQUEST'
export const ORDER_CREATE_COMPLETE = '@CINCH/ORDER_CREATE_COMPLETE'
export const ORDER_CREATE_ERROR = '@CINCH/ORDER_CREATE_ERROR'

export const ORDER_DETAILS_UPDATE_REQUEST = '@CINCH/ORDER_DETAILS_UPDATE_REQUEST'
export const ORDER_DETAILS_UPDATE_COMPLETE = '@CINCH/ORDER_DETAILS_UPDATE_COMPLETE'
export const ORDER_DETAILS_UPDATE_ERROR = '@CINCH/ORDER_DETAILS_UPDATE_ERROR'

export const ORDER_DETAILS_REQUEST = '@CINCH/ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_COMPLETE = '@CINCH/ORDER_DETAILS_COMPLETE'
export const ORDER_DETAILS_ERROR = '@CINCH/ORDER_DETAILS_ERROR'
export const ORDER_DETAILS_UPDATED = '@CINCH/ORDER_DETAILS_UPDATED'

export const PARTEX_CLEAR_VALUATION = '@CINCH/PARTEX_CLEAR_VALUATION'

export const PARTEX_CREATE_VALUATION_REQUEST = '@CINCH/PARTEX_CREATE_VALUATION_REQUEST'
export const PARTEX_CREATE_VALUATION_COMPLETE = '@CINCH/PARTEX_CREATE_VALUATION_COMPLETE'
export const PARTEX_CREATE_VALUATION_ERROR = '@CINCH/PARTEX_CREATE_VALUATION_ERROR'

export const PARTEX_UPDATE_APPRAISAL = '@CINCH/PARTEX_UPDATE_APPRAISAL'
export const PARTEX_UPDATE_VRM = '@CINCH/PARTEX_UPDATE_VRM'
export const PARTEX_VARIANT_SELECT = '@CINCH/PARTEX_VARIANT_SELECT'
export const PARTEX_VARIANTS_REQUEST = '@CINCH/PARTEX_VARIANTS_REQUEST'
export const PARTEX_VARIANTS_COMPLETE = '@CINCH/PARTEX_VARIANTS_COMPLETE'
export const PARTEX_VARIANTS_ERROR = '@CINCH/PARTEX_VARIANTS_ERROR'

export const VEHICLE_DETAILS_REQUEST = '@CINCH/VEHICLE_DETAILS_REQUEST'
export const VEHICLE_DETAILS_COMPLETE = '@CINCH/VEHICLE_DETAILS_COMPLETE'
export const VEHICLE_DETAILS_ERROR = '@CINCH/VEHICLE_DETAILS_ERROR'
